import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Profile from "./pages/Profile";
import EditPost from "./pages/EditPost"
import PrivateRoute from "./components/PrivateRoute";
import CreatePost from "./pages/CreatePost";
import Post from "./pages/Post";
// import logo from './logo.svg';
// import './App.css';

function App() {
	return (
		<div className="App">
			<BrowserRouter>
				<Header />
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/post/:postId" element={<Post />} />
					<Route path="/sign-in" element={<SignIn />} />
					<Route path="/sign-up" element={<SignUp />} />
					<Route path="/forgot-password" element={<ForgotPassword />} />
					<Route path="/profile" element={<PrivateRoute />}>
						<Route path="/profile" element={<Profile />} />
					</Route>
					<Route path="/create-post" element={<PrivateRoute />}>
						<Route path="/create-post" element={<CreatePost />} />
					</Route>
					<Route path="/edit-post" element={<PrivateRoute />}>
						<Route path="/edit-post/:postId" element={<EditPost />} />
					</Route>
					<Route path="*" element={<h1 className="pt-60 text-2xl font-bold text-gray-200 text-center items-center">Page Not Found...</h1>} />
				</Routes>
			</BrowserRouter>
			<ToastContainer
				position="bottom-center"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="dark"
			/>
		</div>
	);
}

export default App;
